// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7259":"6530d77045a611e9","9382":"5b37c237f29d7077"}[chunkId] + ".css";
};